import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyBilling = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/billings',

        branches: [],
        branchesLoading: false,

        vehicleTypes: [],
        vehicleTypeLoading: false,
        vehicleTypesLoading: false,

        paymentMethods: [],
        paymentMethodLoading: false,
        paymentMethodsLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,

        vehicleTypes: state => state.vehicleTypes,

        paymentMethods: state => state.paymentMethods,
    },
};
